<template>
  <div class="list">
    <!-- 搜索 v-show="state.searchState.show"-->
    <Row class="search-filter" :class="{'active':searchState}">
      <Col>
      <Card>
        <Form :label-width="80" inline>
          <Form-item label="id">
            <Input v-model="searchData.id" placeholder="id" style="width:187px"></Input>
          </Form-item>
          <Form-item label="status">
            <Select v-model="searchData.status" style="width:200px" clearable :transfer="transfer">
              <Option v-for="item in statusData" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <!-- <Input v-model="searchData.status" placeholder="status" style="width:187px"></Input> -->
          </Form-item>
          <Form-item label="name">
            <Input v-model="searchData.name" placeholder="name" style="width:187px"></Input>
          </Form-item>
          <Form-item label="invoice_type">
            <Select v-model="searchData.invoice_type" style="width:200px" clearable :transfer="transfer">
              <Option v-for="item in filetype" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </Form-item>
          <!-- <Form-item label="filetype" v-if="Object.keys(filetype).length>0">
            <Select v-model="searchData.status" style="width:200px" >
              <Option v-for="item in filetype" :value="item.id" :key="item.name">{{ item.label }}</Option>
            </Select>
          </Form-item> -->

          <div class="clearfix" style="border-top:1px solid #eee;margin-top:-15px;padding-top:10px">
            <span class="pull-right">
              <Button type="primary" icon="ios-search" shape="circle" @click="search()">Search</Button>
              <Button type="primary" icon="ios-close-empty" shape="circle" @click="clean()">Clean</Button>
              <Button type="primary" icon="ios-download-outline" shape="circle" @click="exportData(1)">export</Button>
              <!-- <Button type="primary" icon="ios-download-outline" shape="circle"
                      @click="exportData(2)">export</Button> -->
            </span>

          </div>
        </Form>
      </Card>
      </Col>
    </Row>
    <row class="search-filter" :class="{'active':statusCount}">
      <Col>
      <Card>
        <Tag v-for="(item,index) in statusArr" :key="index" style="margin-right:5px" :color="index=='error'?'red':'blue'">{{index}} : {{item}}</Tag>
      </Card>
      </Col>
    </row>
    <!-- 搜索 /-->
    <Row>
      <Col>
      <Card>
        <div slot="title">
          <!-- <Icon type="ios-film-outline"></Icon>
          List -->
          <!-- <Button type="dashed" @click.native="fixedHeader=!fixedHeader">
            <Icon type="pin"></Icon>
          </Button> -->
          <Button type="success" @click="filemodal = true">
            Add
          </Button>
          <Button type="primary" @click="searchShow" shape="circle">
            <Icon type="funnel"></Icon> filter</Button>
          <Button type="warning" @click="statusShow" shape="circle">
            <Icon type="icon-brush_fill"></Icon> status</Button>
          <!-- <Button type="error" v-if="selection.length>0" @click="deleteTip=true">
            <Icon type="trash-a"></Icon>
            All delete
          </Button> -->
        </div>

        <a href="#" slot="extra" @click.prevent="refresh">
          <Icon type="ios-loop-strong"></Icon>
        </a>
        <Table :loading="loading2" :show-header="showHeader" :height="fixedHeader ? 300 : ''" :size="tableSize" v-if="listData" :data="listData['results']" :columns="columns1" ref="table" @on-select="onSelect" @on-selection-change="onSelectionChange" @on-sort-change="onselectionchange1"></Table>
        <Row>
          <Col span="9" offset="15">
            <Page :total="count" show-total :page-size="pagesize" :current="params.page" show-elevator @on-change="pageChange" style="margin-top: 10px;" @on-page-size-change="PageSizeChange"></Page>
          </Col>
        </Row>
      </Card>
      </Col>
    </Row>
    <!--删除提示  -->
    <Modal v-model="deleteTip" width="360">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>Are you sure</span>
      </p>
      <div style="text-align:center">
        <p>Delete{{selection.length}}item</p>
        <p></p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="deleteBatch">delete</Button>
      </div>
    </Modal>

    <!-- 上传model -->
    <Modal v-model="filemodal" title="Upload" @on-ok="" @on-cancel="">
      <div slot="footer">
        <Button size="small" @click="cancel">cancel</Button>
      </div>
      <p>
        <Form :label-width="80" inline>
          <Form-item label="Invoice type">
            <Select v-model="fileUpload" style="width:200px" clearable :transfer="transfer">
              <Option v-for="item in filetype" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </Form-item>
          <!-- <Upload v-if="fileUpload" action="http://52.194.204.224/argus/api/source_file/myte/11/image/" :before-upload="handleUpload" accept="image/*">
            <Button icon="ios-cloud-upload-outline">Upload</Button>
          </Upload> -->
          <Button icon="ios-cloud-upload-outline" v-if="fileUpload" class="fileinput-button">Upload
            <input class="upload" @change="addImg" type="file">
          </Button>
        </Form>
      </p>
    </Modal>

  </div>
</template>
<script>
// import {test} from "../../assets/js/test.js"
import elementResizeDetectorMaker from "element-resize-detector";
import axios from "axios";
var erd = elementResizeDetectorMaker();
export default {
  name: "Product",
  components: {},
  data() {
    return {
      count: 0,
      pagesize: 30,
      fileUpload: "",
      transfer: true,
      formItem: {
        input: "",
        select: "",
        date: "",
        time: "",
        radio: "",
        checkbox: []
      },
      filemodal: false,
      countData: null,
      statusData: [
        {
          value: "Done",
          label: "Done"
        },
        {
          value: "Review",
          label: "Review"
        },
        {
          value: "New",
          label: "New"
        },
        {
          value: "Ongoing",
          label: "Ongoing"
        },
        {
          value: "Invalid",
          label: "Invalid"
        },
        {
          value: "Error",
          label: "Error"
        },
        {
          value: "Reject",
          label: "Reject"
        }
      ],
      filetype: [],
      statusArr: {},
      statusCount: false,
      searchData: { id: "", status: "", name: "", invoice_type: "" },
      searchState: false,
      editModal: false,
      detailModal: false,
      deleteTip: false,
      showHeader: true, // 是否显示表头 @:show-header
      loading2: false, // 分页loading
      fixedHeader: false, // 是否固定表头 @:height
      tableSize: "small", // @:size
      DateReady: false, // 判断异步数据加载完成，避免报错
      loading: false, // save
      currDate: {}, // 当前编辑和新增的行数据
      currIndex: 0, // 当前编辑和新增的行号
      saveDisabled: false,
      params: {
        page: 1,
        ordering: "-id"
        // limit: 10,
        // category: ''
      },
      selection: [], // 表格选中项
      listData: null, // @:data
      columns1: [
        {
          // @:columns
          type: "selection", // 开启checkbox
          width: 60,
          align: "center"
        },
        {
          title: "id",
          key: "id",
          sortable: "custom"
        },
        {
          title: "invoice_type",
          key: "invoice_type",
          // sortable: true,
          render: (h, params) => {
            // console.log(params)
            let tmp = {}
            for (let item of this.filetype){
               tmp[item.id] = item
            }
            return h(
              "div",
              this.filetype == undefined
                ? ""
                : tmp[params.row.invoice_type]["name"]
                // : this.filetype[params.row.invoice_type]["name"]
            );
            // let tmp = (params.row.file_type in this.filetye) ? ('name' in this.filetype[params.row.file_type] ? this.filetype[params.row.file_type]["name"] : '') : '';
            // return h("div", tmp);
          }
        },
        {
          title: "name",
          key: "name",
          className: "min-width"
        },
        {
          title: "status",
          key: "status"
          // sortable: true
        },
        {
          title: "created",
          key: "created",
          sortable: "custom"
        },
        {
          title: "updated",
          key: "updated",
          sortable: "custom"
        },
        {
          title: "action",
          key: "action",
          width: 170,
          fixed: "right",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    color: "#5cadff"
                  },
                  on: {
                    click: () => {
                      // console.log(params.row.id);
                      var ids = [];
                      var pageItem = {};
                      this.listData.results.forEach(item => {
                        ids.push(item.id);
                      });
                      pageItem["ids"] = ids;
                      pageItem["current"] = params.row.id + "";
                      pageItem["nextUrl"] = this.listData.next + "";
                      pageItem["previousUrl"] = this.listData.previous + "";

                      localStorage.setItem(
                        "urlParams",
                        JSON.stringify(pageItem)
                      );

                      this.$router.push({
                        path: "/detail",
                        query: { id: params.row.id }
                      });
                      // this.show(params.index)
                    }
                  }
                },
                "review"
              )
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "text",
              //       size: "small"
              //     },
              //     style: {
              //       color: "#ff3300"
              //     },
              //     on: {
              //       click: () => {
              //         this.remove(params.index);
              //         this.$api.deleteList(params).then(res => {
              //           if (!res.error) {
              //             this.getData(this.params);
              //             // this.listData = res;
              //             // this.DateReady = true;
              //             // this.loading2 = false;
              //           } else {
              //             this.$Message.error(res.msg);
              //             this.loading2 = false;
              //           }
              //         });
              //       }
              //     }
              //   },
              //   "delete"
              // )
            ]);
          }
        }
      ]
    };
  },
  watch: {
    /**
     * @params 监听参数变化重新获取数据
     * */
    params: {
      handler(val) {
        this.getData(val);
      },
      deep: true
    },
    fixedHeader: {
      handler(val) {
        if (val) {
          this.$Message.info("head fixed");
        }
      }
    },
    currDate: {
      handler(val) {
        for (let i = 0; i < Object.values(val).length; i++) {
          if (Object.values(val)[i] === "") {
            this.saveDisabled = true;
            return;
          } else {
            this.saveDisabled = false;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    state() {
      return this.$store.state.app;
    }
  },
  methods: {
    handleUpload(file) {
      // console.log(file);
      this.loading2 = true;
      // let params = {
      //   "name": file.name
      // }
      this.$api.createTask(params).then(res => {
        if (!res.error) {
          this.listData = res;
          this.DateReady = true;
          this.loading2 = false;
        } else {
          this.$Message.error(res.msg);
          this.loading2 = false;
        }
      });
    },

    cancel() {
      this.filemodal = false;
    },

    addImg(event) {
      let reader = new FileReader();
      let img = event.target.files[0];
      let type = img.type; //文件的类型，判断是否是图片
      let size = img.size; //文件的大小，判断图片的大小
      let imgData = {
        accept: "image/gif, image/jpeg, image/png, image/jpg, application/pdf"
      };
      if (imgData.accept.indexOf(type) == -1) {
        alert("please choose image！");
        return false;
      }
      let params = {
        name: img.name
      };
      var _self = this;
      this.$api.createTask(params).then(res => {
        if (!res.error) {
          this.DateReady = true;
          this.loading2 = false;
          let id = res.id;
          // console.log(img, "");
          let PostData = {
            file: img
          };

          let tmp = {};
          for (let item of this.filetype) {
            tmp[item.id] = item;
          }


          // console.log(PostData, "-------------------------");
          $.ajax({
            url:
              localStorage.getItem("url") +
              "/api/source_file/myte/" +
              id +
              "/" +
              tmp[this.fileUpload]["name"] +
              "/" +
              img.name +
              "/",
            type: "PUT",
            data: img,
            datatype: "json",
            headers: {
              Authorization: "Basic " + localStorage.getItem("token")
            },
            processData: false,
            cache: false,
            contentType: false,
            success: function(result) {
              //关闭对话框
              _self.$Message.success("save success!");
              _self.filemodal = false;
              // _self.getData(_self.params);
              let triggerdata = { status: "start" };
              axios({
                method: "put",
                url:
                  localStorage.getItem("url") +
                  "/api/task_detail/myte/" +
                  id +
                  "/",
                data: triggerdata,
                headers: { Authorization: "Basic " +localStorage.getItem('token')}
              }).then(res => {
                if (!res.error) {
                  _self.loading2 = false;
                  _self.getData(_self.params);
                } else {
                  _self.$Message.error(res.msg);
                  _self.loading2 = false;
                }
              });
            }
          });
        } else {
          this.$Message.error(res.msg);
          this.loading2 = false;
        }
      });
    },

    search() {
      let reg = /^[0-9]+\.?[0-9]*$/;
      if (
        reg.test(this.searchData.id) ||
        this.searchData.id == null ||
        this.searchData.id == ""
      ) {
        this.$set(this.params, "id", this.searchData.id);
        this.$set(this.params, "status", this.searchData.status);
        this.$set(this.params, "name", this.searchData.name);
        this.$set(this.params, "invoice_type", this.searchData.invoice_type);
        localStorage.setItem(`params`, JSON.stringify(this.params));
      } else {
        this.$Notice.error({
          title: "error",
          desc: "enter correct type please "
        });
      }

      // this.params.id = this.searchData.id
      // this.params.status = this.searchData.status
    },

    onselectionchange1(column) {
      console.log(column);
      let params = this.params;
      if (column.order == "normal") {
        this.$set(params, "ordering", column.key);
      }
      if (column.order == "asc") {
        this.$set(params, "ordering", column.key);
      }
      if (column.order == "desc") {
        this.$set(params, "ordering", "-"+column.key);
      }
      this.loading2 = true;
      this.$api.getList(params).then(res => {
        if (!res.error) {
          this.listData = res;
          this.DateReady = true;
          this.loading2 = false;
        } else {
          this.$Message.error(res.msg);
          this.loading2 = false;
        }
      });
    },

    clean() {
      this.searchData = {};
    },

    handleChange(data) {
      this.currDate.time = data;
    },

    searchShow() {
      this.searchState = !this.searchState;
    },

    statusShow() {
      this.statusCount = !this.statusCount;
    },
    /**
     * 刷新页面请求
     * */
    refresh() {
      this.getData(this.params);
    },
    /**
     * @params:category 分类 page：页码 limit:条数
     * */
    getData(params) {
      this.loading2 = true;
      this.$api.getList(params).then(res => {
        if (!res.error) {
          this.listData = res;
          this.count = res.count;
          this.DateReady = true;
          this.loading2 = false;
        } else {
          this.$Message.error(res.msg);
          this.loading2 = false;
        }
      });
    },

    getCount() {
      axios({
        method: "get",
        url: localStorage.getItem("url") + "/api/summary_info/myte/",
        // data: PostData,
        headers: { Authorization: "Basic " +localStorage.getItem('token')}
      }).then(res => {
        if (!res.error) {
          this.statusArr = res.data;
        } else {
          this.$Message.error(res.msg);
          this.loading2 = false;
        }
      });
    },

    getfiletype() {
      this.loading2 = true;
      this.$api.getfiletype().then(res => {
        this.getData(this.params);
        if (!res.error) {
          // let obj = {};
          // for (let item of res.results) {
          //   // obj.item.id = item
          //   let id = item.id.toString();
          //   obj[id] = item;
          // }
          this.filetype = res.results;
          // this.DateReady = true;
          this.loading2 = false;
        } else {
          this.$Message.error(res.msg);
          this.loading2 = false;
        }
      });
    },

    /**
     * @on-change 页码改变的回调，返回改变后的页码
     * */
    pageChange(page) {
      this.params.page = page;
    },
    /**
     * @on-page-size-change 切换每页条数时的回调，返回切换后的每页条数
     * */
    PageSizeChange(limit) {
      this.params.limit = limit;
    },
    /**
     * 表格对应操作方法
     * @show 查看
     * @remove 删除
     * @edit
     */
    remove(index) {
      this.listData.results.splice(index, 1);
    },
    edit(index) {
      this.editModal = true;
      this.currIndex = index;
      if (index === -1) {
        // 新增
        this.currDate = {
          amount: "",
          name: "",
          operator: "",
          time: "",
          desc: "",
          price: "",
          fromWhere: ""
        };
      } else {
      }
    },
    /**
     * 批量删除
     */
    deleteBatch() {
      this.deleteTip = false;
      // ...
    },
    saveBatch() {
      this.loading = true;

      this.$api.createCollection(this.currDate).then(res => {
        if (!res.error) {
          this.loading = false;
          this.$Message.info("保存成功");
          this.editModal = false;
          this.refresh();
        } else {
          this.$Message.error(res.msg);
          this.loading2 = false;
        }
      });
    },
    /**
     * 数据导出
     * @ type 1 原始数据 2过滤数据
     */
    exportData(type) {
      if (type === 1) {
        this.$refs.table.exportCsv({
          filename: "原始数据"
        });
      } else if (type === 2) {
        this.$refs.table.exportCsv({
          filename: "排序和过滤后的数据",
          original: false
        });
      }
    },
    /**
     * 多选
     * selection：已选项数据 row：刚选择的项数据
     */
    onSelect(selection, row) {
      // console.log(selection, row);
    },
    onSelectionChange(selection) {
      this.selection = selection;
    }
  },
  created() {
    // this.getData(this.params);
    this.getCount();
    this.getfiletype();
    // this.params = this.$route.params.page==undefined?this.params:JSON.parse(localStorage.getItem('params'))
    this.params.page =
      this.$route.params.page == undefined ? 1 : this.$route.params.page;
    if (this.$route.params.page == undefined) {
      this.params = this.params;
    } else {
      // this.params.page = JSON.parse(localStorage.getItem('params'))
      this.searchData.id = JSON.parse(localStorage.getItem("params")).id;
      this.searchData.name = JSON.parse(localStorage.getItem("params")).name;
      this.searchData.status = JSON.parse(
        localStorage.getItem("params")
      ).status;
      this.searchData.invoice_type = JSON.parse(
        localStorage.getItem("params")
      ).invoice_type;
      this.search();
    }
  },
  beforeUpdate() {
    // this.getfiletype();
  },
  mounted() {
    erd.listenTo(window, "resize", this.handleResize);
  }
};
</script>
<style lang="less" scoped>

.fileinput-button {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.upload {
  position: absolute;
  right: 0px;
  top: 0px;
  opacity: 0;
  -ms-filter: "alpha(opacity=0)";
  font-size: 200px;
}
.ivu-upload {
  display: inline-block;
}
.search-filter {
  opacity: 0;
  display: none;
  overflow: hidden;
  transition: all 0.28s ease-out;
  &.active {
    opacity: 1;
    display: block;
  }
}
</style>




// WEBPACK FOOTER //
// Index.vue?6c0dc064